export interface ListaArquivosFeedbackResult {
  id?: string;
  Id?: string;
  filePath?: string;
  FilePath?: string;
  originalFileName?: string;
  OriginalFileName?: string;
}

export interface ArquivosFeedbackResult {
  registroContatoOperacionalId?: string;
  RegistroContatoOperacionalId?: string;
  clienteContactId?: string;
  ClienteContactId?: string;
  tipoFeedback?: number;
  TipoFeedback?: number;
  dataInclusao?: string;
  DataInclusao?: string;
  arquivos?: ListaArquivosFeedbackResult[];
  Arquivos?: ListaArquivosFeedbackResult[];
}
